import { render, staticRenderFns } from "./pieGroup2.vue?vue&type=template&id=2a0f22cb&scoped=true&"
import script from "./pieGroup2.vue?vue&type=script&lang=js&"
export * from "./pieGroup2.vue?vue&type=script&lang=js&"
import style0 from "./pieGroup2.vue?vue&type=style&index=0&id=2a0f22cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f22cb",
  null
  
)

export default component.exports